<template>
  <section id="contacto" class="site-contacto">
    <b-container fluid class="pt-3 pb-5">
      <b-row class="py-5" align-h="center">
        <h2 class="section-title text-white">Contacto</h2>
      </b-row>
      <b-row class="pb-5 h-100" align-h="center">
        <b-col lg="5" class="form-col">
          <Form />
        </b-col>
        <b-col lg="5">
          <b-row class="h-100">
            <b-col sm="12" class="h-33 pb-2">
            <MapCardTTS />
            </b-col>
            <b-col sm="12" class="h-33 pb-2">
            <MapCardTijuana />
            </b-col>
            <b-col sm="12" class="h-33">
              <MapCardSanDiego />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Form from '../components/Form'
import MapCardTTS from '../components/MapCardTTS'
import MapCardTijuana from '../components/MapCardTijuana'
import MapCardSanDiego from '../components/MapCardSanDiego'

export default {
  name: 'Contacto',
  components: {
    Form,
    MapCardTTS,
    MapCardTijuana,
    MapCardSanDiego
  }
}
</script>

<style scoped>
.site-contacto{
  background-image: url("../assets/Contacto.jpg");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.section-title {
  font-size: 48px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

@media only screen and (max-width: 768px) {
  .form-col{
    margin-bottom: 1rem;
  }
}

</style>
